module.exports = __webpack_public_path__ + "static/img/icon-success.634e8354.png";